// Import normalizr library
import {schema} from 'normalizr'

/*** rgv schemas ***/
// leads schema
const lead = new schema.Entity('leads')
export const leadSchema = { lead: lead }
export const leadsSchema = { leads: { 'collection': [lead] } }

const product = new schema.Entity('products')
const style = new schema.Entity('styles', {
  products: [product]
});
const category = new schema.Entity('categories', {
  styles: [style]
});
export const categorySchema = { category: category }
export const categoriesSchema = { categories: { 'collection': [category] } }


const user = new schema.Entity('users')
export const userSchema = { user: user }
export const usersSchema = { users: { 'collection': [user] } }
